/**
 * @generated SignedSource<<5a74d339dcfee1b81e2d9cc82f24c259>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingInfoModal_HideEventMutation$variables = {
  guid: string;
};
export type MeetingInfoModal_HideEventMutation$data = {
  readonly hideEvent: {
    readonly ok: boolean | null;
  } | null;
};
export type MeetingInfoModal_HideEventMutation = {
  response: MeetingInfoModal_HideEventMutation$data;
  variables: MeetingInfoModal_HideEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "guid"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "guid",
        "variableName": "guid"
      }
    ],
    "concreteType": "HideEventMutation",
    "kind": "LinkedField",
    "name": "hideEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingInfoModal_HideEventMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingInfoModal_HideEventMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d7a1f9aae8a7ec30205cb61f8772694b",
    "id": null,
    "metadata": {},
    "name": "MeetingInfoModal_HideEventMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingInfoModal_HideEventMutation(\n  $guid: String!\n) {\n  hideEvent(guid: $guid) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "7bb81fc9254e54c21b3dbd0ed982ac7d";

export default node;
